import { useEffect, useRef, useState } from "react";

// Shared open/close scaffold for the navbar PrimeReact dropdowns
// (Periodicity / ChartType / BarColor). Extracted verbatim from the three
// copies (dedup audit 2026-07-17, item 6a): outside-click detection that
// respects appendTo={document.body}, plus the focus-restore routine that
// returns keyboard focus to #cursor-toggle-btn after the panel closes.
export default function useNavbarDropdown() {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  // Improved outside click detection that respects appendTo={document.body}
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!isOpen) return;

      const dropdownElement = dropdownRef.current?.getElement();
      const dropdownPanel = document.querySelector(".p-dropdown-panel");

      // Check if click is outside both the dropdown button AND the dropdown panel
      const clickedOutside =
        dropdownElement &&
        !dropdownElement.contains(event.target) &&
        (!dropdownPanel || !dropdownPanel.contains(event.target));

      if (clickedOutside) {
        dropdownRef.current?.hide();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [isOpen]);

  const onShow = () => {
    setIsOpen(true);
  };

  const onHide = () => {
    setIsOpen(false);
    // When dropdown closes, ensure it loses focus completely
    setTimeout(() => {
      // Remove focus from any dropdown elements
      const dropdownElements = document.querySelectorAll(
        ".p-dropdown, .p-dropdown-panel, .p-dropdown-item",
      );
      dropdownElements.forEach((el) => {
        if (el && el.blur) {
          el.blur();
        }
      });

      // Blur the currently active element to ensure dropdown loses focus
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }

      // Make sure body is focusable and focus it
      document.body.tabIndex = -1;
      document.body.focus();

      // Then focus the cursor button
      setTimeout(() => {
        const cursorButton = document.getElementById("cursor-toggle-btn");
        if (cursorButton) {
          cursorButton.focus();
        }
      }, 50);
    }, 10);
  };

  return { dropdownRef, onShow, onHide };
}
